import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";
import CgnButtonDropdown from "../toolbox/CgnButtonDropdown";

class DimensionalTemplateList extends Component {
  state = {
    pageTitle: "Boyutsal Ölçüm Şablon Listele",
    pageAddLink: "boyutsal-olcum-sablon-ekle",
    pageUpdateLink: "boyutsal-olcum-sablon-guncelle",
    pageDetailLink: "boyutsal-olcum-sablon-detay",
    pageListLink: "boyutsal-olcum-sablon-listele",
    breadcrumb: [{ text: "Boyutsal Ölçüm Şablon", link: "#" }],
    isLoading: false,
    isDeleted: false,
    status: false,
    dimensionalTemplateData: [],
    guid: "",
    documents: "",
    measurement: "",
    tolerance: "",
    alertErrorMessage: "",
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var statusType = 1; // 1 aktif ve pasiflerin ikisinide getirmesi için
    axios
      .get(URL + "/dimensionalTemplates/getlist/" + statusType, config)
      .then((response) => {
        this.setState({
          dimensionalTemplateData: response.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  handleDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.deleteItem(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };

  async deleteItem(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/dimensionalTemplates/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  thStyle = {
    width: "120px",
  };

  thStyle2 = {
    width: "150px",
  };

  tdStyle = {
    width: "200px",
  };

  tdStyle2 = {
    width: "300px",
  };

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row className="canalList" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              <CgnDatatable
                data={this.state.dimensionalTemplateData}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Boyutsal Ölçüm Şablon Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      return (
                        <Table className="table table-responsive ">
                          <tbody>
                           <tr>
                           <th style={this.thStyle}>Ref. Bölge</th>
                              <td style={this.tdStyle}>{row.documents}</td>
                              <th style={this.thStyle2}> Gerek/Ölçü (cm)</th>
                              <td>{row.measurement}</td>
                            </tr>
                            <tr>
                            <th style={this.thStyle}>Tolerans</th>
                              <td style={this.tdStyle}>{row.tolerance}</td>
                              <th style={this.thStyle2}>Ekleyen Kullanıcı </th>
                              <td>{row.createdBy}</td>
                            </tr>                   
                          </tbody>
                        </Table>
                      );
                    },
                  },                           
                  {
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, cell) => (
                      <CgnButtonDropdown
                        label={"Yönet"}
                        className="mr-0"
                        color="primary"
                        items={[
                          {
                            text: CgnMessage.updateButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageUpdateLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.detailButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageDetailLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.deleteButton,
                            className: "dropDownBtn",
                            onClick: () => this.handleDelete(row.guid),
                          },
                        ]}
                      />
                    ),
                  },
                ]}
                loading={this.state.isLoading}
              />
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default DimensionalTemplateList;
